import { SiteIdOverrideConfig } from "stores/wizard/config";
import { defaultLocationValue_en } from "../../staticConfigs/thirdPartyPackage/thirdPartyPackageConfig";
import { defaultOriginsSiteId10122006, defaultDestinationsSiteId10122006 } from "./siteId10122006";

// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
export const siteId10122006_en_GB: SiteIdOverrideConfig = {
  package: {
    navigation: {
      tabTitleToken: "wizard.package.tab.title.variant.1.label",
    },
  },
  thirdPartyPackage: {
    origins: [defaultLocationValue_en, ...defaultOriginsSiteId10122006],
    destinations: [defaultLocationValue_en, ...defaultDestinationsSiteId10122006],
  },
};
